const colors = {
    primary: '#FD2D01',
    secondary: '#FFD7D7',
    tertary : '#4E5166',
    black: '#000000',
    white: '#FFFFFF',
}

export default colors